module.exports = __webpack_public_path__ + "img/ph_phone-bold.7f394c72.svg";